import IAppState from './IAppState';

const stateKey = 'mc_state';


// Methods to save and retrieve state to and from local storage.
export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(stateKey);

        if (serializedState === null) {
            return undefined;
        }

        return JSON.parse(serializedState);
    } catch (e) {
        console.log(`Error in retrieving state from local storage. ` + e);
        return undefined;
    }
};

export const saveState = (stateObj) => {
    try {
        const serializedState = JSON.stringify(stateObj);
        localStorage.setItem(stateKey, serializedState);
    } catch (e) {
        console.log(`Error in persisting state to local storage. ` + e);
    }
};

export const clearState = () => {
    try {
        localStorage.removeItem(stateKey);
    } catch (e) {
        console.log(`Error in clearing state in local storage. ` + e);
    }
};



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/store/local-storage.ts